<template>
  <b-card
    :img-src="require('@/assets/images/banner/banner-12.jpg')"
    img-alt="Bienvenido a su salon de clases"
    img-top
    class="card-profile"
  >
    <div class="profile-image-wrapper">
      <div class="profile-image p-0">
        <b-avatar
          size="114"
          variant="light"
          :src="require(`@/assets/images/pages/forgot-password.png`)"
        />
      </div>
    </div>
    <h3>{{ getSession.cuenta }}</h3>
    <h6 class="text-muted">
      {{ getAccount.email }}
    </h6>
    <b-badge
      class="profile-badge"
      variant="light-primary"
    >
      {{ $store.getters['cuenta/rolCurrent'].nombre }}
    </b-badge>
    <hr class="mb-2">

    <!-- despliegue de opciones -->
    <!-- <div
      class="d-flex justify-content-between align-items-center"
    >
      <div>
        <h6 class="text-muted font-weight-bolder">
          Followers
        </h6>
        <h3 class="mb-0">
          10.3k
        </h3>
      </div>
      <div>
        <h6 class="text-muted font-weight-bolder">
          Projects
        </h6>
        <h3 class="mb-0">
          156
        </h3>
      </div>
      <div>
        <h6 class="text-muted font-weight-bolder">
          Rank
        </h6>
        <h3 class="mb-0">
          23
        </h3>
      </div>
    </div> -->
    <b-row
      class="mt-4"
    >
      <b-button
        variant="relief-secondary"
        block
        :disabled="(flagcontinue) ? false : true"
        @click="redirectModle()"
      >
        {{ (flagcontinue) ? 'Ir a clases' : 'Lo sentimos no tiene el salon habilitado.' }}
      </b-button>
    </b-row>
    <!--/ follower projects rank -->
  </b-card>
</template>

<script>
import {
  BRow, BCard, BAvatar, BBadge, BButton,
} from 'bootstrap-vue'
import store from '@/store'
import { ref, onMounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import {
  isEmptyObject,
} from '@core/utils/utils'
// import { useToast } from 'vue-toastification/composition'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCard,
    BBadge,
    BAvatar,
    BButton,
  },
  directives: {
    Ripple,
  },
  computed: {
    getSession() {
      if (isEmptyObject(this.$store.getters['cuenta/getSession'])) {
        return ({
          uid: 1,
          persona: 'Alumno',
          cuenta: '/alumno/dashboard',
          token: 'ff9c4286-0e1f-46d9-9695-217df3bcd811',

        })
      } return this.$store.getters['cuenta/getSession']
    },
    getAccount() {
      return this.$store.getters['cuenta/getAccount']
    },
  },
  setup() {
    // const toast = useToast()
    const flagcontinue = ref(false)
    const verificando = () => {
      if (store.state.cuenta.session.tknmdl != null) {
        flagcontinue.value = true
      }
    }

    const redirectModle = () => {
      // usar siempre https, para envio de credenciales
      const routeData = `${process.env.VUE_APP_MOODLE_API}${process.env.VUE_APP_SERVICE_APIMDL}?token=${store.state.cuenta.session.tknmdl}&task=redirect`
      window.location.replace(routeData)
    }

    onMounted(
      () => {
        verificando()
      },
    )

    return {
      verificando,
      flagcontinue,
      redirectModle,
    }
  },
}
</script>
